module.exports = __webpack_public_path__ + "media/images/gym-73ea501e.jpg";